import { render, staticRenderFns } from "./basicDeviceInformation.vue?vue&type=template&id=65037153&scoped=true&"
import script from "./basicDeviceInformation.vue?vue&type=script&lang=js&"
export * from "./basicDeviceInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65037153",
  null
  
)

export default component.exports